export enum LocalStorageKeys {
  TOKEN = "SSO_TOKEN",
}
